import createCachedSelector from "re-reselect";
import * as actions from "./actionCreators";

const defaultFilters = {
  uniqueId: "",
  partnerName: ""
};

const ids = (filters, page, state) => {
  const key = actions.loadContractsKey(filters);
  const contractsForRestructuring = state.document.leasingContracts[key];
  if (!contractsForRestructuring) {
    return [];
  }

  const result = contractsForRestructuring[page] ? contractsForRestructuring[page].ids : [];
  return result ? result : [];
};

const contractsForRestructuring = (filters, page, state) =>
  state.entities.contractsForRestructuring ? state.entities.contractsForRestructuring : [];

export const getContractsForRestructuringCached = createCachedSelector(
  ids,
  contractsForRestructuring,
  (ids, contractsForRestructuring) => ids.map(id => contractsForRestructuring[id])
)((filters, _page, _state) => actions.loadContractsKey(filters));

export const getContractsForRestructuring = (filters, state) => {
  const page = 1;
  const key = actions.loadContractsKey(filters, page);
  const contractsForRestructuring = state.document.leasingContracts[key];

  const loading =
    contractsForRestructuring && contractsForRestructuring[page] ? contractsForRestructuring[page].loading : false;
  const loaded =
    contractsForRestructuring && contractsForRestructuring[page] ? contractsForRestructuring[page].loaded : false;
  const totalCount =
    contractsForRestructuring && contractsForRestructuring.totalCount ? contractsForRestructuring.totalCount : 0;
  const content = loaded ? getContractsForRestructuringCached(filters, page, state) : [];

  return { loading, loaded, content, totalCount };
};

export const getFilters = state => {
  return state?.document?.leasingContracts?.filters || defaultFilters;
};
